
import Grid from '@mui/material/Grid2';
import React, { useContext, useEffect, useState } from 'react'
import globalStyles from '../Styles/global.module.scss';
import SideNavigationPanel from '../Components/SideNavigationPanel/SideNavigationPanel';
import { Outlet, useLocation } from 'react-router-dom';
import { GlobalUserContext, GlobalUserContextPayload } from '../Context/GlobalUserDetailContext';
import AdminAppNavbar from '../Components/AdminAppNavbar/AdminAppNavbar';
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import AppNavbar from '../Components/AppNavbar/AppNavbar';
import MenuIcon from '@mui/icons-material/Menu';
import { useIsBelow1200 } from '../Utils/Constant/Constant';
import Plan401kChildren from './Dashboard/DashboardNavbar/DashboardNavbarChildren/Plan401kChildren';
// import { isBelow1200 } from '../Utils/Constant/Constant';


const MainComponent = () => {

    const { drawerOpen,
        setDrawerOpen,
        userProfileDetails,
        currentSelectedTab,
        isAdminNavbarVisible,
        userRole
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const isBelow1200 = useIsBelow1200()
    const pathName = window.location.pathname.toLowerCase()

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [headerName, setHeaderName] = useState<string>("")

    const handleDrawerClose = () => {
        setMobileOpen(false);
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };


    useEffect(() => {
        if (pathName == '/dashboard' || pathName == '/') {
            setHeaderName("Dashboard")
        }
        else if (pathName.includes('/dashboard/revenue')) {
            setHeaderName("Dashboard")
        }
        else if (pathName === '/dashboard/401k-fee-comparison') {
            setHeaderName("Dashboard")
        }
        else if (pathName === '/dashboard/marketing-and-sales') {
            setHeaderName("Dashboard")
        }
        else if (pathName.includes('/member')) {
            setHeaderName("Member")
        }
        else if (pathName.includes('/member/user')) {
            setHeaderName("Member")
        }
        // else if (pathName === '/user-app-access') {
        //     setHeaderName("User App Access")
        // }
        else if (pathName.includes('/profile')) {
            setHeaderName("Profile")
        }
        else {
            setHeaderName("")
        }

    }, [pathName])


    return (
        <>
            <Grid container className={`${globalStyles.mainContainer}`}>
                <Grid size={{ xs: 12 }} className={`${globalStyles.fullHeightStyle}`}>
                    <Grid container className={`${globalStyles.fullHeightStyle}`}>
                        <Grid
                            className={`${globalStyles.fullHeightStyle}`}
                            sx={{
                                width: `${isBelow1200 ? "0px" : drawerOpen ? "250px" : '80px'}`
                            }}
                        >
                            <SideNavigationPanel
                                handleDrawerClose={handleDrawerClose}
                                mobileOpen={mobileOpen}
                            />
                        </Grid>
                        <Grid
                            className={`${globalStyles.fullHeightStyle} ${globalStyles.globalContentBgWrapper}`}
                            sx={{
                                width: `${isBelow1200 ? "100%" : drawerOpen ? "calc(100% - 250px) !important" : "calc(100% - 80px) !important"}`,
                                maxWidth: `${isBelow1200 ? "100%" : drawerOpen ? "calc(100% - 250px) !important" : "calc(100% - 80px) !important"}`,
                                overflow: 'auto',
                                // marginTop: isBelow1200 ? "70px" : "0px"
                            }}
                        >
                            <Grid container className={`${globalStyles.gblHeaderOutletContainer}`}
                                sx={{ backgroundColor: isBelow1200 ? "#273348" : "transparent" }}
                            >
                                <Grid size={{ xs: 12 }}>
                                    <Grid container
                                        sx={{
                                            alignItems: "baseline !important",
                                            gap: "5px",
                                            padding: isBelow1200 ? "15px 10px" : "0px 20px"
                                        }}
                                    >
                                        {isBelow1200 && (
                                            <Grid size={{ xs: 12 }}>
                                                <Grid container sx={{ justifyContent: "space-between", alignItems: 'center' }}>

                                                    <Grid className={`${globalStyles.menuIconItem}`} sx={{ width: "30px", maxWidth: "30px" }}>
                                                        <IconButton
                                                            sx={{ padding: "0px", margin: "0px", }}
                                                            onClick={handleDrawerToggle}
                                                        >
                                                            <MenuIcon sx={{ color: "white" }} />
                                                        </IconButton>
                                                    </Grid>

                                                    <Grid className={`${globalStyles.menuTextItem}`}>
                                                        <Grid container>
                                                            <Typography component={'span'} className={`${globalStyles.globalTextV15} ${globalStyles.gblCWhite}`}>
                                                                {headerName}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        )
                                        }
                                        {/* <Grid size={{ xs: "grow" }}>
                                            <AppNavbar
                                                flagShowDivider={isBelow1200 ? false : true}
                                                isBelow1200={isBelow1200}
                                                children={renderHeaderButtons()}
                                            />
                                        </Grid> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid size={{ xs: 12 }} className={`${globalStyles.globalOutletWrapper}`}>
                                    <Outlet />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default MainComponent